import { FilterApplicability, FilterConnector, IconKind, TriggerKind } from "~/shared/enums";
import type { Automation, Dartboard } from "~/shared/types";
import type { DataStore } from "~/stores/DataStore";
import { getPageDisplayName, makeUuid } from "~/utils/common";

export const AUTOMATION_QUERY_PARAM = "automation";
export const PSEUDO_BUILTIN_DUID = "@builtin";

export const hasCustomAutomationIcon = (automation: Automation) =>
  automation.iconKind !== IconKind.NONE && automation.iconNameOrEmoji !== "";

export const getDartboardDefaultsAutomation = (dataStore: DataStore, dartboard: Dartboard): Automation | undefined =>
  dataStore.automationList.find(
    (automation) =>
      automation.triggerKind === TriggerKind.TASK_CREATE &&
      automation.currentConditions.some(
        (condition) =>
          condition.propertyDuid === dataStore.defaultDartboardProperty.duid &&
          condition.values.includes(dartboard.duid)
      )
  );

export const getOrCreateDartboardDefaultsAutomation = async (
  dataStore: DataStore,
  dartboard: Dartboard
): Promise<Automation> => {
  const existingAutomation = getDartboardDefaultsAutomation(dataStore, dartboard);
  if (existingAutomation) {
    return existingAutomation;
  }

  return dataStore.createAutomation(undefined, {
    enabled: false,
    title: `Defaults for ${getPageDisplayName(dartboard, dataStore.getSpaceByDuid) || "dartboard"}`,
    triggerKind: TriggerKind.TASK_CREATE,
    currentConditions: [
      {
        id: makeUuid(),
        propertyDuid: dataStore.defaultDartboardProperty.duid,
        applicability: FilterApplicability.IS,
        connector: FilterConnector.OR,
        values: [dartboard.duid],
      },
    ],
  });
};
